import { MyTableComponent, Input } from "components"
import { useState, useEffect } from "react"
import { Box } from "theme-ui"
import tittle from "./Tittle.png"
import selectIcon from "./selecticon.png"
import { useFetchDeviceSignalGroupsQuery } from "../../store/Features/devices/deviceSignalGroups-api-slice"

import { IDeviceSignalGroupSignalElements } from "@types"
import { useTranslation } from "react-i18next"

export const SignalGroupTable = () => {
 const { t } = useTranslation("translation")
 const { data, isLoading } = useFetchDeviceSignalGroupsQuery()

 const [selectedData, setSelectedData] = useState<IDeviceSignalGroupSignalElements[]>([])
 const [allData, setAllData] = useState<IDeviceSignalGroupSignalElements[]>([])
 const [selectedIndex, setSelectedIndex] = useState(0)

 const columns = [
  { Header: t("number"), accessor: "signal_number" },
  { Header: "Name", accessor: "signal_name" },
  { Header: "Status", accessor: "state" },
 ]

 useEffect(() => {
  if (data) {
   data && setSelectedData(data[0]?.signal_elements)

   data && setAllData(data[0]?.signal_elements)
  }
  // eslint-disable-next-line
 }, [data])
 const searchHandler = (keyword: string) => {
  if (keyword !== "") {
   const filterData: IDeviceSignalGroupSignalElements[] = allData?.filter(
    (item) => item?.signal_name?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
   )
   setSelectedData([...filterData])
  } else {
   setSelectedData(allData)
  }
 }
 // method for changing active button color
 const handleActive = (index: number) => {
  setSelectedIndex(index)
 }

 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full">
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("signalGroups")}</h1>
    <div className="flex lg:w-[6%] w-[15%] justify-between">
     <button className="bg-white h-6 w-6 rounded-lg flex items-center justify-center ">
      <img className="rotate-[-90deg]" src={selectIcon} alt="prev" />
     </button>
     <button className="bg-white h-6 w-6 rounded-lg flex items-center justify-center ">
      <img className="rotate-90" src={selectIcon} alt="next" />
     </button>
    </div>
   </div>
   <Box bg="highlight">
    <ul className="flex w-[100%] Jakarta-font overflow-x-auto hide-scroll-icon ">
     {data?.map((single, index) => (
      <div
       className={`flex bg-light-gray2 rounded py-3 text-black px-2 ${
        selectedIndex === index ? "bg-white rounded font-bold" : ""
       }`}
       key={index}
       onClick={() => {
        setSelectedData(single?.signal_elements)
        setAllData(single?.signal_elements)
        handleActive(index)
       }}
      >
       <div>
        <li className="text-xs opacity-70 cursor-pointer lg:min-w-[30%] min-w-[50%] ">
         {single?.common_information.server_name}
        </li>
       </div>
       <div>
        <li className="text-xs opacity-70 cursor-pointer lg:min-w-[30%] min-w-[50%]">
         {single?.common_information.device_name}
        </li>
       </div>
      </div>
     ))}
    </ul>
    <div className="py-3 px-3 flex justify-between items-center">
     <div>
      {data?.map((single, index) => (
       <h1 key={index} className="Jakarta-font font-semibold">
        {selectedIndex === index && (
         <div>
          {single?.common_information.server_name}:{single?.common_information.device_name}{" "}
         </div>
        )}
       </h1>
      ))}
     </div>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">{t("category")}</p>

      <div className="bg-white h-8 w-12  mx-4  border-light-gray border-[1.5px] rounded flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder={t("search")}
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
    isLoading={isLoading}
   />
  </div>
 )
}
